var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Instagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ea0029;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M666.91,490.62A2.39,2.39,0,1,0,669.3,493,2.39,2.39,0,0,0,666.91,490.62Z",
    transform: "translate(-655.41 -481.39)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M669.92,485.87h-6a4.1,4.1,0,0,0-4.1,4.1v6a4.09,4.09,0,0,0,4.1,4.1h6A4.1,4.1,0,0,0,674,496v-6A4.11,4.11,0,0,0,669.92,485.87Zm-3,10.83A3.69,3.69,0,1,1,670.6,493,3.69,3.69,0,0,1,666.91,496.7Zm3.81-6.66a.86.86,0,1,1,.86-.86A.86.86,0,0,1,670.72,490Z",
    transform: "translate(-655.41 -481.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Instagram);
export default __webpack_public_path__ + "static/media/01_Instagram.333cc57ba098b374cc933ce362aaffb2.svg";
export { ForwardRef as ReactComponent };